var _a, _DonationSocketioModel_socket, _DonationSocketioModel_createSocket;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import io from 'socket.io-client';
export class DonationSocketioModel {
    constructor(host, privateKey) {
        _DonationSocketioModel_socket.set(this, void 0);
        __classPrivateFieldSet(this, _DonationSocketioModel_socket, __classPrivateFieldGet(_a, _a, "m", _DonationSocketioModel_createSocket).call(_a, host, privateKey), "f");
        __classPrivateFieldGet(this, _DonationSocketioModel_socket, "f").on('connect', () => {
            console.log('connected');
        });
    }
}
_a = DonationSocketioModel, _DonationSocketioModel_socket = new WeakMap(), _DonationSocketioModel_createSocket = function _DonationSocketioModel_createSocket(host, privateKey) {
    return io.connect(`http://${host}?type=channel&key=${privateKey}`);
};
